export const firebaseConfig = {
    apiKey: "AIzaSyDrw3r6BpIepVelRPKv-22Qgf17GvHPjG4",
    authDomain: "portfolio-17915.firebaseapp.com",
    databaseURL: "https://portfolio-17915.firebaseio.com",
    projectId: "portfolio-17915",
    storageBucket: "portfolio-17915.appspot.com",
    messagingSenderId: "102911467764",
    appId: "1:102911467764:web:7fc3ca8c1488c2a7",
    measurementId: "G-BXEDTV4JJJ"
};